import root from 'window-or-global';

/**
 * This file should not be imported by components.  The prop.message object passed into EpicGamesNav should be used instead.
 * This is just a reference and default in case there is not message props.
 * @type {Object}
 */
const defaultMessages = {
    locale: 'Locale',
    search: 'Search',
    search_bar: 'Search...',
    sign_in: 'Sign In',
    sign_out: 'Sign Out',
    default_username: 'Account',
    default_download: 'Get Epic Games'
};

//allow the root._epicGamesNav.messages to override the constants
if (root._epicGamesNav && root._epicGamesNav.messages) {
    for (const message in defaultMessages) {
        if (root._epicGamesNav.messages[message]) {
            defaultMessages[message] = root._epicGamesNav.messages[message];
        }
    }
}

module.exports = defaultMessages;



// WEBPACK FOOTER //
// ./app/scripts/constants/defaultMessages.js